import { render, staticRenderFns } from "./ArticleEmplacementsManager.vue?vue&type=template&id=caf0d64a&scoped=true&"
import script from "./ArticleEmplacementsManager.vue?vue&type=script&lang=js&"
export * from "./ArticleEmplacementsManager.vue?vue&type=script&lang=js&"
import style0 from "./ArticleEmplacementsManager.vue?vue&type=style&index=0&id=caf0d64a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "caf0d64a",
  null
  
)

export default component.exports